import { BlogQueryParams } from "components/Blog/Blog.constants";
import { TSuggestedSearchItem } from "components/Blog/Blog.types";
import { debounce } from "helpers";
import { useQueryParams } from "hooks";
import { useCallback, useState } from "react";
import * as R from "ramda";
import { Select } from "shared";
import axios from "axios";
import { TOption } from "shared/Select/Select";
import { createSearchParams, useNavigate } from "react-router-dom";
import { useStyleContext } from "components/StyleContext/StyleContext";
import { STYLES } from "../../../../../constants";
import { IconName } from "shared/IconComponent/IconComponent";

type TSearchInputProps = {
  inputValue: string;
  setInputValue: (value: string) => void;
  apiBaseUrl: string;
  placeholder: string;
  noOptionsMessage?: string;
  defaultQueryParams: any;
};

function SearchInput({
  inputValue,
  setInputValue,
  apiBaseUrl,
  placeholder,
  noOptionsMessage = "No results",
  defaultQueryParams,
}: TSearchInputProps) {
  const { style } = useStyleContext();
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const searchTerm =
    (R.prop(BlogQueryParams.SearchTerm, queryParams) as string) || "";

  const realQueryParams = R.mergeLeft(queryParams, defaultQueryParams);

  const setSearchTerm = (value: string) => {
    const newQueryParams = {
      [BlogQueryParams.SortBy]: R.prop(BlogQueryParams.SortBy, realQueryParams),
      [BlogQueryParams.ActivePage]: 1,
      [BlogQueryParams.PageSize]: R.prop(
        BlogQueryParams.PageSize,
        realQueryParams
      ),
      [BlogQueryParams.SearchTerm]: value,
    };

    navigate({
      pathname: "/",
      search: `?${createSearchParams({ ...newQueryParams } as any)}`,
    });
  };

  // eslint-disable-next-line
  const loadSuggestiveSearchOptions = useCallback(
    debounce(async (query: string, callback: (options: any) => void) => {
      return query?.length >= 2
        ? axios
            .get(apiBaseUrl + `BlogSuggestResult/?word=${query}`)
            .then((res: { data: TSuggestedSearchItem[] }) => {
              const options = res?.data?.map((opt: TSuggestedSearchItem) => ({
                label: opt?.Name,
                value: opt?.Value,
              }));

              callback(options);
            })
        : callback([]);
    }, 500),

    []
  );

  return (
    <Select
      isAsync
      placeholder={placeholder}
      loadOptions={loadSuggestiveSearchOptions}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          setSearchTerm(inputValue);
          setIsMenuOpen(false);

          event.preventDefault();
        }
      }}
      value={null}
      onChange={(value) => {
        window.location.href = (value as TOption)?.value as string;
      }}
      inputValue={inputValue}
      onInputChange={(value) => {
        setInputValue(value);
      }}
      menuIsOpen={isMenuOpen}
      onMenuOpen={() => setIsMenuOpen(true)}
      onMenuClose={() => {
        setIsMenuOpen(false);
        setInputValue(searchTerm);
      }}
      noOptionsMessage={() => noOptionsMessage}
      iconName={style === STYLES.EG ? IconName.Question : undefined}
    />
  );
}

export default SearchInput;
